import React, { useContext, useState } from 'react';
import * as Yup from 'yup';
import { useHistory } from 'react-router-dom';
import { Field, Form, Formik } from 'formik';

import { Header, Footer } from 'components';
import { Button } from 'components';
import { InputField, Section } from 'components/Form';
import { Col, Row } from 'components/Grid';

import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import { BaseWrapper } from '../../styles';
import { ChangePasswordContainer, ButtonContainer } from './styles';


export default function ChangePasswordPage() {

  console.log("ChangePasswordPage - BEGIN");

  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);

  const firstLoginState = authContext.firstLogin;
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loginState, setLoginState] = useState(authContext.status);
  const [changePasswordState, setChangePasswordState] = useState(authContext.changedPassword);
  const [changePasswordMessage, setChangePasswordMessage] = useState('Por favor informe as novas informações de conta');
  const changePasswordLinkText = (authContext.status == true && firstLoginState != true) ?? 'clique aqui';
  const changePasswordLinkAnchor = (authContext.status == true && firstLoginState != true) ?? 'login';

  const history = useHistory();

  const goToHomePage = () => {
    history.push('home');
  };

  const goToLoginPage = () => {
    history.push('login');
  };

  return (
    <BaseWrapper>
      <ChangePasswordContainer>
        <Row>
          <Col md={12} sm={12} lg={12}>
            <Header title="Alteração de senha" subtitle={changePasswordMessage} linkText={changePasswordLinkText} linkAnchor={changePasswordLinkAnchor}></Header>
          </Col>
        </Row>

        <Formik
          initialValues={{
            username: authContext.username || '',
            password: '',
            new_password: '',
            new_password_confirm: '',
          }}

          validationSchema={Yup.object({
            username: Yup.string().email('Invalid email').required('* Campo obrigatório'),
            password: Yup.string().required('* Campo obrigatório'),
            new_password: Yup.string().required('* Campo obrigatório').test('match', 'A senha atual e nova não podem ser iguais',
              function (new_password) {
                return new_password !== this.parent.password
              }).matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/, `
              Senha senha deve ter ao menos 8 caracters de comprimento e conter: 1 letra maiúscula, 1 letra minúscula, 1 caracter especial e 1 dígito numérico.
              `),
            new_password_confirm: Yup.string().required('* Campo obrigatório').test('match', 'As senhas devem ser iguais',
              function (new_password_confirm) {
                return new_password_confirm == this.parent.new_password
              })
          })}

          onSubmit={values => {

            loading.start();

            console.log("onSubmit - BEGIN");

            const fitinsur = new FitinsurAPI();
            const mc = new MessageCenter();
            //fitinsur.requestChangePassword(values.username, values.password)
            fitinsur.requestChangePassword(values.username, values.password, values.new_password)
              .then((response) => {
                console.log(response);
                return response.json();
              })
              .then((data) => {
                console.log('requestChangePassword - Success:', data);
                authContext.login_response = data;
                if (data.ret_code == 200) {
                  authContext.status = false;
                  authContext.username = values.username;
                  //authContext.token = data.ret_token;
                  if (data.ret_token) authContext.token = data.ret_token; // LEGACY LOGIN
                  if (data.ret_value.token) authContext.token = data.ret_value.token; // LOGIN V2                  
                  authContext.person_product = data.ret_person_product;
                  authContext.user_region = data.ret_user_region;
                  authContext.firstLogin = false;
                  authContext.changedPassword = true;

                  console.log("requestChangePassword: authContext");
                  console.log(authContext);
                  /* setLoginState(false); */
                  history.push('login');
                  /* 
                                    setChangePasswordMessage('Your password was changed sucessfully, to proceed with the login, please ');
                                    setChangePasswordLinkText('click here');
                                    setChangePasswordLinkAnchor('login');
                                    setChangePasswordState(true);
                                  
                                    setFirstLoginState(false); */
                } else {
                  authContext.status = false;
                  authContext.username = values.username;
                  authContext.token = "";
                  authContext.person_product = [];
                  authContext.user_region = "";
                  authContext.firstLogin = false;
                  authContext.changedPassword = false;

                  setChangePasswordMessage('Erro trocando a senha');
                  setChangePasswordState(false);
                }
                Header.subtitle = changePasswordMessage;
                loading.stop();
              })
              .catch((error) => {

                authContext.status = false;
                authContext.username = values.username;
                authContext.token = "";
                authContext.person_product = [];
                authContext.user_region = "";
                authContext.firstLogin = false;
                authContext.changedPassword = false;

                console.error('requestChangePassword - Error:', error);
                setChangePasswordMessage('Erro trocando a senha');
                setChangePasswordState(false);
                loading.stop();
              });

            console.log("onSubmit - END");
          }}
        >

          {(props) => (
            <Form>
              <Section>

                <Row>
                  <Col xs={12} md={12}>
                    <Field
                      name="username"
                      label="E-mail:"
                      type="text"
                      component={InputField}
                      isRequired
                      hideLabelAsterisk
                    /* disabled={changePasswordState == true && firstLoginState != true} */
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} md={12}>
                    <Field
                      name="password"
                      label="Senha Atual:"
                      component={InputField}
                      isRequired
                      hideLabelAsterisk
                      rightIcon = {showPassword ? "closedEye" : "openEye"}
                      rightIconClick = {() => setShowPassword(state => !state)}
                      type={showPassword ? "text" : "password"}

                    /* disabled={changePasswordState == true && firstLoginState != true} */
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} md={12}>
                    <Field
                      name="new_password"
                      label="Nova Senha:"
                      component={InputField}
                      isRequired
                      hideLabelAsterisk
                      rightIcon = {showConfirmPassword ? "closedEye" : "openEye"}
                      rightIconClick = {() => setShowConfirmPassword(state => !state)}
                      type={showConfirmPassword ? "text" : "password"}

                    /* disabled={changePasswordState == true && firstLoginState != true} */
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} md={12}>
                    <Field
                      name="new_password_confirm"
                      label="Confirme a Nova Senha:"
                      component={InputField}
                      isRequired
                      hideLabelAsterisk
                      rightIcon = {showNewPassword ? "closedEye" : "openEye"}
                      rightIconClick = {() => setShowNewPassword(state => !state)}
                      type={showNewPassword ? "text" : "password"}

                    /* disabled={changePasswordState == true && firstLoginState != true} */
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} md={12} style={{ position: "static" }}>
                    <ButtonContainer>
                      <Button
                        primary type="submit"
                        id="btnChangePassword"
                        style={{}}
                          /* disabled={changePasswordState == true && firstLoginState != true} */>
                        Confirmar
                        </Button>
                    </ButtonContainer>
                  </Col>

                </Row>
              </Section>


            </Form>
          )}

        </Formik>
      </ChangePasswordContainer>
      <Footer />
    </BaseWrapper>

  );
}
